<div  class="custom-b-position-menu" *ngIf="mapCtrl.locationBButtonStateOn">
    <div id="custom-b-position-content">
        <div class="position-title-bar">
            <div class="position-title-text" i18n>Localizare adresa</div>

            <div>
                <span class="glyphicon glyphicon-info-sign position-title-info" ngbPopover="{{infoPositionSearch}}"
                    popoverTitle="Info" i18n popoverClass="text-dark" triggers="mouseenter:mouseleave"
                    placement="bottom" onclick="event.stopPropagation()">
                </span>
            </div>
            <div (click)="onClickPositionClose(); $event.stopPropagation()">
                <span class="material-icons position-title-close">close</span>
            </div>

        </div>
        <div>
            <form #positionForm="ngForm" novalidate (submit)="onSearchPositionByGeocoding()">
                <div class="row position-no-margin">
                    <ul ngbNav #nav="ngbNav" [(activeId)]="locationBData.selectedOption"
                        class="nav-tabs nav-fill w-100">
                        <li [ngbNavItem]="'search'" (click)="onChangePositionOption('search')">
                            <a ngbNavLink i18n>Căutare locație</a>
                            <ng-template ngbNavContent>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="'gps'" (click)="onChangePositionOption('gps')">
                            <a ngbNavLink i18n>Coordonate GPS</a>
                            <ng-template ngbNavContent>
                            </ng-template>
                        </li>
                        <!-- <li [ngbNavItem]="'center'"
                    (click)="onChangePositionOption('center')">
                        <a ngbNavLink i18n>Centru</a>
                        <ng-template ngbNavContent>
                        </ng-template>
                    </li> -->
                    </ul>
                </div>
                <div *ngIf="locationBData.selectedOption === 'search'">
                    <div class="row m-0">
                        <div class="col-10 p-0">

                            <div class="form-group my-0">
                                <label class="form-label mb-0">Strada</label>
                                <input type="search" name="strada" [(ngModel)]="locationBData.strada"
                                    class="form-control">
                            </div>
                            <div class="form-group my-0">
                                <label class="form-label mb-0">Număr</label>
                                <input type="search" name="numar" [(ngModel)]="locationBData.numar"
                                    class="form-control">
                            </div>
                            <div class="form-group my-0">
                                <label class="form-label mb-0">Loacalitate</label>
                                <input type="search" name="localitate" [(ngModel)]="locationBData.localitate"
                                    class="form-control">
                            </div>
                        </div>
                        <div class="col-2 p-0 pt-4 pb-2">
                            <div class="w-100 h-100 d-flex justify-content-end">
                                <button title="Caută locații" i18n-title type="submit" class="btn btn-light"
                                    [disabled]="locationBData.disableSearch" (click)="onSearchPositionByGeocoding()">
                                    <i class="fa fa-search "></i></button>
                            </div>
                        </div>

                    </div>
                </div>
                <div *ngIf="locationBData.selectedOption === 'gps'">
                    <div class="row m-0">
                        <div class="col-10 p-0">
                            <div class="form-group my-0">
                                <label class="form-label mb-0">Longitudine</label>
                                <input type="search" name="long" [(ngModel)]="locationBData.long" class="form-control">
                            </div>
                            <div class="form-group my-0">
                                <label class="form-label mb-0">Latitudine</label>
                                <input type="search" name="lat" [(ngModel)]="locationBData.lat" class="form-control">
                            </div>
                        </div>
                        <div class="col-2 p-0 pt-4 pb-2">
                            <div class="w-100 h-100 d-flex justify-content-end">
                                <button title="Caută locații" i18n-title type="submit" class="btn btn-light"
                                    [disabled]="locationBData.disableSearch" (click)="onSearchPositionByGeocoding()">
                                    <i class="fa fa-search "></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="position-search">
                    <div class="position-search-input">
                        <input type="search" name="search" [(ngModel)]="locationBData.searchText" class="form-control"
                            [disabled]="locationBData.disableSearch">
                    </div>
                    <div class="position-search-button">
                        <button title="Caută locații" i18n-title type="submit"
                            class="position-search-button btn btn-light" [disabled]="locationBData.disableSearch">
                            <i class="fa fa-search "></i></button>
                    </div>
                </div>
                <div class="position-search-option-uat">
                    <input name="unitatiTeritoriale" id="unitatiTeritoriale" type="checkbox"
                        [(ngModel)]="locationBData.numaiUnitatiTeritoriale" [disabled]="locationBData.disableSearch" />
                    <label for="unitatiTeritoriale" style="font-weight: unset;" i18n> Numai unități teritoriale</label>
                </div> -->
                <div *ngIf="locationBData.showLocationList">
                    <!-- search results-->
                    <div *ngFor="let location of locationBData.locations">
                        <div class="position-result" (click)="onClickPositionResults(location)"
                            *ngIf="isVisibleLocation(location) === true">
                            <div class="position-result-figure">
                                <span class="material-icons position-result-figure-icon">location_on</span>
                            </div>
                            <div class="position-result-content">
                                {{location.strada}} - {{location.numar}}, <span
                                    *ngIf="location == locationBData.selectedLocation"
                                    class="glyphicon glyphicon-info-sign float-right mr-1"
                                    (click)="onClickPositionShowInfo(location)"></span>
                            </div>

                        </div>
                    </div>
                    <!-- -->
                    <h6 *ngIf="locationBData.activeSearchLocations" class="position-spiner-box">
                        <i id="spinner" class="fa fa-circle-o-notch fa-spin position-spiner"></i>
                    </h6>
                </div>


                <!-- location info -->
                <div *ngIf="locationBData.showLocationInfo">
                    <div class="mt-1 font-weight-bold">Informații despre locație: <span
                            (click)="onClickPositionHideInfo(null)"
                            class="glyphicon glyphicon-remove float-right mr-1"></span></div>
                    <div class="mb-2 font-weight-bold">{{locationBData.selectedLocation.strada}} -
                        {{locationBData.selectedLocation.numar}}</div>
                    <div *ngFor="let locinfo of locationBData.locationResultInfo" class="my-1 border-bottom"
                        (click)="onClickNetowrkInfo(locinfo)">
                        <div *ngFor="let info of locinfo.info">
                            {{info}}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>